import React, { useState, useEffect } from 'react';

// Define the types for the component's props
interface TypingTextProps {
  text: string;
  speed: number; // Speed in milliseconds per character
}

const TypingText: React.FC<TypingTextProps> = ({ text, speed }) => {
  const [displayedText, setDisplayedText] = useState<string>('');

  useEffect(() => {
    setDisplayedText(''); // Reset displayed text when 'text' prop changes

    const timeouts: NodeJS.Timeout[] = []; // Specify type for timeouts array

    for (let i = 0; i < text.length; i += 1) {
      // Changed ++i to i += 1 for consistency
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[i]);
      }, i * speed);

      timeouts.push(timeout);
    }

    // Cleanup function: clear all scheduled timeouts
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [text, speed]); // Depend on 'text' and 'speed' props

  return <span>{displayedText}</span>;
};

export default TypingText;
